<template>
    <FormSection
        title="Race/Ethnicity"
        type="his-section"
        :full-height="false"
        :application-id="Number(currentApplication)"
    >
        <template #content>
            <section class="row py-3 pb-0 g-0">
                <div class="col-12 col-lg-12 px-4 col-md-12 g-0">
                    <p class="mb-2 d-flex align-items-center field-title">
                        <span class="badge me-1">A1005</span> Are you of Hispanic, Latino/a, or Spanish origin? (Check
                        all that apply)
                    </p>
                    <div v-for="ethnicity of referralOptions.ethnicity" :key="`${ethnicity.value}-${ethnicity.text}`">
                        <div
                            :class="`form-check custom-checkbox ms-2 pb-1 ${
                                isEthnicityDisabled(ethnicity.value) ? 'disabled-checkbox' : ''
                            }`"
                        >
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :id="`ethnicity-${ethnicity.value}`"
                                :disabled="isEthnicityDisabled(ethnicity.value)"
                                :checked="referral.Demographics.EthnicitiesOnlyCollection.includes(ethnicity.value)"
                                @change="handleEthnicity(ethnicity.value)"
                            />

                            <label class="form-check-label" :for="`ethnicity-${ethnicity.value}`">
                                <small>{{ ethnicity.text }}</small>
                            </label>
                        </div>
                    </div>
                </div>
            </section>
            <section class="row py-3 g-0">
                <div class="col-12 col-lg-12 px-4 col-md-12 g-0">
                    <p class="mb-2 d-flex align-items-center field-title">
                        <span class="badge me-1">A1010</span> What is your race? (Check all that apply)
                    </p>
                    <div v-for="race of referralOptions.race" :key="`${race.value}-${race.text}`">
                        <div
                            :class="`form-check custom-checkbox pb-1 ms-2 ${
                                isRaceDisabled(race.value) ? 'disabled-checkbox' : ''
                            }`"
                        >
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :disabled="isRaceDisabled(race.value)"
                                :id="`race-${race.value}`"
                                :checked="referral.Demographics.RacesCollection.includes(race.value)"
                                @change="handleRace(race.value)"
                            />
                            <label class="form-check-label" :for="`race-${race.value}`">
                                <small>{{ race.text }}</small>
                            </label>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./RaceEthnicity.ts"></script>
<style src="./RaceEthnicity.scss"></style>
